import {AdvertisingPlatformCodeEnum} from '@dms/api/shared';

import {PlatformPhotoSettings} from './PlatformPhotoSettings';

export function PlatformSettingsVgp() {
  return <PlatformPhotoSettings platformCode={AdvertisingPlatformCodeEnum.VGP} />;
}
